export enum RecorderStateKey {
    UNEXPECTED_EXCEPTION,
    INITIALIZING,
    INITIALIZED,
    PRE_W3_LOOKUP,
    WAITING_FOR_W3,
    WAITING_FOR_64BIT_W3,
    ANALYZING_W3,
    ADMIN_REQUIRED,
    PRE_GAME_LOOKUP,
    WAITING_FOR_GAME,
    GAME_STARTING,
    GAME_STARTED,
    GAME_RUNNING,
    GAME_ENDED,
    RECORDER_STOPS,
    UNSUPPORTED_W3_VERSION // Keep existing native state numbers stable.
}

export enum RecorderMessageType {
    RECORDER_STATE,
    LOCAL_MATCHUP,
    LOCAL_GAMEDATA,
    GAMEDATA,
    MATCHUP,
    LEGACY_RESERVED_5, // Keep native recorder message numbers stable.
    PING,
    SWITCH_PLATFORM,
    REQUEST_ADMIN,
    GAMETIME,
    APPLICATION_DATA,
    BNET_CONTEXT,
    BNET_STATS,
    AUTHENTICATE
}

export type RecorderRuntimeEvent =
    | { type: 'matchup'; data: any }
    | { type: 'gametime'; seconds: number };

export interface RecorderRuntimeStartOptions {
    userId: string;
    isPro: boolean;
    localBackend: boolean;
}
